/*
Suresh Peddavoora 12/16/2022 2701127043 Added Class Name for Text Fields
Raghu 12/30/2022 2701127043 added column for text fields
Raghu 01/03/2022 2701127043 Added class name for text feilds.
Prakash 01/16/2023 2701127043 Fixed Responsiveness.
Raghu 02/21/2023 2701127043 changed buttons color
Raghu 02/23/2023 2701127043 fixed new ui changes
Raghu 03/01/2023 2701127043 fixed new ui changes
*/
import {Button, withStyles} from '@material-ui/core';
import {Autocomplete} from '@mui/material';
import React, {useContext} from 'react';
import GuiTextField from '../../../../../../components/FormComponents/GuiTextField';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
const DefaultOpenAutoComplete = withStyles({
  popperDisablePortal: {
    // position: "relative !important",
  },
})(Autocomplete);
const AddRuleSelectField = ({
  label,
  options = [],
  optionLable,
  groupBy,
  value,
  name,
  handleChange,
  handleInsert,
  placeholder = '',
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  return (
    <div className="global-field-textfields new-standard-textfields add-calculation-rule col-md-6 col-xl-3 col-lg-4">
      <DefaultOpenAutoComplete
        classes={{
          option: classes.option,
        }}
        size="small"
        value={value}
        name="function"
        options={options ? options : []}
        groupBy={groupBy}
        getOptionLabel={optionLable}
        onChange={handleChange}
        fullWidth
        open={true}
        disablePortal
        autoSelect={false}
        ListboxProps={{
          style: {
            maxHeight: '130px',
          },
        }}
        autoHighlight
        renderInput={(params) => (
          <div className="select-field">
            <GuiTextField
              {...params}
              variant="outlined"
              margin="dense"
              // InputLabelProps={{
              //   shrink: true,
              // }}
              label={label}
              className={` ${classes.labelName}`}
              placeholder={placeholder}
            />
          </div>
        )}
      />
      <Button
        variant="outlined"
        onClick={handleInsert}
        className={`search-btn ml-1 mb-3 ${classes.buttonRoot} box-btn`}
      >
        Insert
      </Button>
    </div>
  );
};

export default AddRuleSelectField;
